import { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import styled from "styled-components";
import { listarObservacoesPrevias } from "../../../services/api-inss.service";

const ContainerTimeLine = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e2f2ff;
  border-radius: 8px;
  padding: 1rem;
  width: 100%;
  max-height: 55rem;
  overflow-y: auto;
  gap: 8px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: inset 0px 4px 10px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

function formatDate(date) {
  if (!date) return "";
  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return String(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth()+1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} - ${hh}h${mi}`;
  } catch {
    return String(date);
  }
}

const ModalObservacoesInss = ({ open, onClose, idPreviaOrCnpj, titulo = "Observações (INSS)" }) => {
  const [loading, setLoading] = useState(false);
  const [observacoes, setObservacoes] = useState([]);

  useEffect(() => {
    if (!open || !idPreviaOrCnpj) return;
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const resp = await listarObservacoesPrevias(idPreviaOrCnpj);
        if (!mounted) return;
        const list = resp?.observacoes || [];
        setObservacoes(Array.isArray(list) ? list : []);
      } catch (e) {
        setObservacoes([]);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [open, idPreviaOrCnpj]);

  const content = useMemo(() => {
    if (loading) return <Typography variant="body2">Carregando...</Typography>;
    if (!observacoes?.length) return <Typography variant="body2">Nenhuma observação encontrada.</Typography>;
    return (
      <ContainerTimeLine>
        {observacoes.map((o) => (
          <Card key={o.id || `${o.cnpj}-${o.data}-${o.observacao?.slice(0,10)}`}>
            <Typography variant="subtitle2" sx={{fontWeight:600}}>
              {o.usuario || "Observação"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {formatDate(o.data)}
            </Typography>
            {o.titulo ? (
              <Typography variant="body2" sx={{mt:0.5}}>{o.titulo}</Typography>
            ) : null}
            <Typography variant="body2" sx={{whiteSpace:'pre-wrap'}}>
              {o.observacao}
            </Typography>
          </Card>
        ))}
      </ContainerTimeLine>
    );
  }, [loading, observacoes]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{display:'flex',alignItems:'center',gap:1}}>
        <HistoryIcon fontSize="small"/>
        {titulo}
        <IconButton onClick={onClose} sx={{ml:'auto'}}>
          <CloseIcon/>
        </IconButton>
      </DialogTitle>
      <Divider/>
      <DialogContent dividers>
        {content}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalObservacoesInss;
